import type { IconItem, ProcessPhase } from '@/types'

import {
    AlarmClock,
    BadgeCheck,
    ShieldCheck,
    UserRound
} from 'lucide-react'

export const teamHighlights: Array<string> = [
    "Besplatne konsultacije",
    "Osiguranje i zaštita imovine",
    "Stručan nadzor"
]

export const processPhases: Array<ProcessPhase> = [
    {
        title: "Pripremni radovi",
        description: "Čišćenje terena, nivelisanje i priprema podloge.",
        image: '/images/faza-pripremni.jpg',
        imageAlt: "Radnik u radnom kombinezonu ispred merdevina"
    },
    {
        title: "Građevinski radovi",
        description: "Sve faze građenja, od početka do kraja projekta.",
        image: '/images/faza-gradjevinski.jpg',
        imageAlt: "Betonski zid sa geometrijskim uzorkom"
    },
    {
        title: "Završni radovi",
        description: "Malterisanje, gletovanje i dekorativni radovi.",
        image: '/images/faza-zavrsni.jpg',
        imageAlt: "Dva radnika valjkom farbaju veliku površinu sa visećeg podesta"
    },
    {
        title: "Instalacioni radovi",
        description: "Elektro i vodoinstalacije, sanitarije i klimatizacija.",
        image: '/images/faza-instalacioni.jpg',
        imageAlt: "Kablovi uključeni u instalacioni panel"
    }
]

export const whyUs: Array<IconItem> = [
    {
        title: "Garancija na radove",
        description: "Dajemo garanciju na sve izvedene radove našeg tima.",
        icon: ShieldCheck
    },
    {
        title: "Individualan pristup",
        description: "Radove prilagođavamo Vašim potrebama i budžetu.",
        icon: UserRound
    },
    {
        title: "Poštivanje rokova",
        description: "Poštujemo rokove i redovno Vas izvještavamo o napretku.",
        icon: AlarmClock
    },
    {
        title: "Kvalitet i sigurnost",
        description: "Provjereni standardi i materijali za trajne rezultate.",
        icon: BadgeCheck
    }
]

export const budgetOptions: Array<string> = [
    "Do 10.000 KM",
    "10.000 do 50.000 KM",
    "50.000 do 150.000 KM",
    "Preko 150.000 KM",
    "Još ne znam"
]

export const timelineOptions: Array<string> = [
    "Što prije",
    "U naredna 3 mjeseca",
    "Za 3 do 6 mjeseci",
    "Za više od 6 mjeseci",
    "Samo se informišem"
]

export const quoteNextSteps: Array<{ title: string, description: string }> = [
    {
        title: "Pregledamo Vaš upit",
        description: "Naš tim pročita svaki upit i javlja Vam se u najkraćem mogućem roku."
    },
    {
        title: "Besplatne konsultacije",
        description: "Dogovaramo obilazak objekta i razgovaramo o Vašim željama, budžetu i rokovima."
    },
    {
        title: "Ponuda prilagođena Vama",
        description: "Dobijate jasnu ponudu i plan radova, bez ikakve obaveze."
    }
]
